import React from 'react';

// ===========================
// 📚 DONNÉES BAC MAROCAIN
// ===========================
export const baccalaureatMarocain = [
  { code: '3A33358100', libelle: 'Bac Arts Appliqués' },
  { code: '3A33222011', libelle: 'Bac Langue Arabe' },
  { code: '3A33122010', libelle: 'Bac Lettres' },
  { code: '3A33122210', libelle: 'Bac Lettres - Option Anglais' },
  { code: '3A33122310', libelle: 'Bac Lettres - Option Espagnole' },
  { code: '3A33122110', libelle: 'Bac Lettres - Option Français' },
  { code: '3A33192010', libelle: 'Bac Lettres- Option Sport Etude' },
  { code: 'O1', libelle: 'Bac Originel' },
  { code: '3A33500400', libelle: 'Bac Pro - Art et Techniques du Bois' },
  { code: '3A33500500', libelle: 'Bac Pro - Construction Métallique' },
  { code: '3A33500200', libelle: 'Bac Pro - Fabrication Mécanique' },
  { code: '3A33700300', libelle: 'Bac Pro -Arts Culinaires' },
  { code: '3A33700100', libelle: 'Bac Pro -Commerce' },
  { code: '3A33700200', libelle: 'Bac Pro -Comptabilité' },
  { code: '3A33500600', libelle: 'Bac Pro -Dessin de Bâtiment' },
  { code: '3A33500700', libelle: 'Bac Pro -Electrotechnique; Equipts. Com' },
  { code: '3A33500800', libelle: "Bac Pro -Froid et Conditionnement d'air" },
  { code: '3A33501300', libelle: 'Bac pro -Froid industriel' },
  { code: '3A33700800', libelle: 'Bac Pro -Gestion-Administration' },
  { code: '3A33500900', libelle: 'Bac Pro -Gros Œuvres du bâtiment' },
  { code: '3A33700600', libelle: 'Bac Pro -logistique' },
  { code: '3A33501000', libelle: 'Bac Pro -Maintenance de Véhicules Auto(Voitures)' },
  { code: '3A33500100', libelle: 'Bac Pro- Maintenance Industielle' },
  { code: '3A33501100', libelle: 'Bac Pro -Maintenance Informatique et Réseaux' },
  { code: '3A33700700', libelle: 'Bac pro -Réception hôtel' },
  { code: '3A33700400', libelle: 'Bac Pro -Services de Restauration' },
  { code: '3A33700500', libelle: 'Bac Pro -Stylisme Modélisme' },
  { code: '3A33501200', libelle: 'Bac Pro -Systèmes Electroniques  Numériques' },
  { code: '3A33501400', libelle: 'Bac Pro.-Energies Renouvelables(Systèmes énergie Solaire)' },
  { code: '3A33600100', libelle: 'Bac Professionnel - Cond. exploitation agricole' },
  { code: '3A33500300', libelle: 'Bac Professionnel - Construction Aéronautique' },
  { code: '3A33142012', libelle: 'Bac Sciences Agricoles' },
  { code: '3A33222010', libelle: 'Bac Sciences Chariaa' },
  { code: '3A33334411', libelle: 'Bac Sciences de la gestion Comptable' },
  { code: '3A33142010', libelle: 'Bac Sciences de la Vie et de la Terre' },
  { code: '3A33142210', libelle: 'Bac Sciences de la Vie et de la Terre - Option An' },
  { code: '3A33142310', libelle: 'Bac Sciences de la Vie et de la Terre - Option Es' },
  { code: '3A33142110', libelle: 'Bac Sciences de la Vie et de la Terre - Option Fr' },
  { code: '3A33190010', libelle: 'Bac Sciences de la Vie et de la Terre- Option Sport Etude' },
  { code: '3A33334010', libelle: 'Bac Sciences Economiques' },
  { code: '3A33394010', libelle: 'Bac Sciences Economiques- Option Sport Etude' },
  { code: '3A33142000', libelle: 'Bac Sciences Expérimentales' },
  { code: '3A33352200', libelle: 'Bac Sciences et Technologies Electrique' },
  { code: '3A33352100', libelle: 'Bac Sciences et Technologies Mécanique' },
  { code: '3A33122011', libelle: 'Bac Sciences Humaines' },
  { code: '3A33122211', libelle: 'Bac Sciences Humaines - Option Anglais' },
  { code: '3A33122311', libelle: 'Bac Sciences Humaines - Option Espagnole' },
  { code: '3A33122111', libelle: 'Bac Sciences Humaines - Option Français' },
  { code: '3A33192011', libelle: 'Bac Sciences Humaines- Option Sport Etude' },
  { code: '3A33146010', libelle: 'Bac Sciences Mathématiques A' },
  { code: '3A33146210', libelle: 'Bac Sciences Mathématiques A - Option Anglais' },
  { code: '3A33146310', libelle: 'Bac Sciences Mathématiques A - Option Espagnole' },
  { code: '3A33146110', libelle: 'Bac Sciences Mathématiques A - Option Français' },
  { code: '3A33146011', libelle: 'Bac Sciences Mathématiques B' },
  { code: '3A33146211', libelle: 'Bac Sciences Mathématiques B - Option Anglais' },
  { code: '3A33146311', libelle: 'Bac Sciences Mathématiques B - Option Espagnole' },
  { code: '3A33146111', libelle: 'Bac Sciences Mathématiques B - Option Français' },
  { code: '3A33142011', libelle: 'Bac Sciences Physiques' },
  { code: '3A33142211', libelle: 'Bac Sciences Physiques - Option Anglais' },
  { code: '3A33142311', libelle: 'Bac Sciences Physiques - Option Espagnole' },
  { code: '3A33142111', libelle: 'Bac Sciences Physiques - Option Français' },
  { code: '3A31650000', libelle: 'Tronc commun Professionnel Agricole' },
  { code: '3A31500000', libelle: 'Tronc commun Professionnel Industiel' }
];

// ===========================
// 🌍 DONNÉES BAC ÉTRANGER
// ===========================
export const baccalaureatEtranger = [
  { code: 'E10', libelle: 'Economie Bac Pro' },
  { code: 'E3', libelle: 'Economique' },
  { code: 'E8', libelle: 'Enseignement Originel' },
  { code: 'E2', libelle: 'Lettres' },
  { code: 'E7', libelle: 'Lettres Sciences Humaines' },
  { code: 'E5', libelle: 'Professionnel' },
  { code: 'E15', libelle: 'Professionnel Secteur Secondaire' },
  { code: 'E1', libelle: 'Sciences' },
  { code: 'E16', libelle: 'Sciences Expérimentales' },
  { code: 'E12', libelle: 'Sciences Agricoles' },
  { code: 'E11', libelle: 'Sciences de la Vie de la Terre' },
  { code: 'E14', libelle: 'Sciences Mathématiques' },
  { code: 'E13', libelle: 'Sciences Physiques' },
  { code: 'E4', libelle: 'Technique' }
];

// ===========================
// 🎓 DIPLÔMES D'ACCÈS
// ===========================
export const diplomesAcces = [
  'Diplôme',
  "Diplôme d'Etudes Universitaire en Sciences et Techniques",
  'Brevet de Technicien Supérieur',
  'Baccalauréat',
  'Doctorat',
  'Ancien Master',
  'Master spécialisé',
  'Master en Sciences et Techniques',
  'Licence des études fondamentales',
  'Diplôme des études universitaires générales',
  'Ancien Diplôme de docteur en médecine',
  'Ancien Diplôme de docteur en médecine dentaire',
  'Diplôme des études générales dans les sciences et techniques',
  'Ancien Diplôme traducteur',
  'Ancien Diplôme de docteur en pharmacie',
  'Ancien Licence en sciences et techniques',
  'Licence professionnelle',
  'Ancien Diplôme universitaire de technologie',
  'Ancien Diplôme des écoles nationales de commerce et gestion',
  "Ancien Diplôme d'ingénieur d'état",
  'Doctorat',
  "Diplôme d'études supérieures approfondies",
  "Doctorat d'Etat",
  "Diplôme d'études supérieures spécialisées",
  "Diplôme National de Spécialité d'Orthodentie",
  'Diplôme de Spécialité Médicale',
  'Diplôme des études universitaires professionnelles',
  'Licence en éducation',
  "Ancien Diplôme d'interprète",
  'Diplôme en traduction audio visuelle',
  'Diplôme INAU',
  "Diplôme de Cycle Supérieur de l'Institut Supérieur International de Tourisme",
  "Diplôme du Cycle Normal de l'Institut Supérieur International de Tourisme",
  'Diplôme de Capitaine au Long Cours',
  'Cycle fondamental INSAP',
  "ISCAE-Diplôme du Groupe Institut Supérieur de Commerce et d'Administration des Entreprises",
  "Diplôme d'informatiste",
  "Diplôme d'informatiste spécialisé",
  "Ancien Diplôme des Métiers d'Art et de Design",
  "Ancien Diplôme de l'Ecole Nationale Supérieure d'Art et de Design",
  'Brevet de technicien spécialisé',
  'Bachelor',
  "Attestation d'admissibilité au CNC",
  'Diplôme de technicien spécialisé',
  'Diplôme de Spécialité Pharmaceutique et Biologique',
  'Architecte',
  "Diplôme d'Administrateur des Affaires Maritimes",
  'Diplôme de Capitaine Mécanicien de 1ère classe de la Marine Marchande',
  'Diplôme de Cycle Normal en Information et Communication',
  'Diplôme de Cycle Supérieur',
  'Diplôme de Lieutenant au Long Cours',
  'Diplôme de Lieutenant Mécanicien de 1ère classe de la Marine Marchande',
  "Diplôme de l'Institut National des Beaux Arts",
  'Diplôme du Cycle Normal',
  "Diplôme National d'Expert Comptable",
  "Diplôme Officier Ingénieur d'Etat",
  'Diplôme Supérieur de Traduction',
  'Docteur Vétérinaire',
  'Docteur Vétérinaire Spécialisé',
  "Certificat d'aptitude à l'enseignement secondaire",
  'Certificat du deuxième cycle des écoles normales supérieures',
  'Certificat du cycle supérieur délivré par les écoles normales supérieures',
  'Classes Préparatoires aux Grandes Ecoles',
  "Diplôme du Cycle Normal de l'Institut Supérieur des Etudes Maritimes",
  "Diplôme du Cycle supérieur de l'Institut Supérieur des Etudes Maritimes",
  'Licence Bac + 3 ans',
  'Bac + 3 ans (S5/S6)',
  'Master 2 ans après un diplôme "Bac+3ans"',
  'Diplôme des Etudes Préparatoires en Commerce et Gestion',
  'Diplôme des écoles nationales de commerce et de gestion',
  'Diplôme universitaire de technologie',
  "Diplôme des études Préparatoires en sciences de l'ingénieur",
  "Diplôme d'ingénieur d'état 5 ans après Baccalauréat en Ingénierie",
  '2 années Préparatoires en Ingénierie',
  'Ancien Années Préparatoires',
  'Licence professionnelle (S5/S6)',
  'Diplôme de Spécialité Médicale (médiacale)',
  '3 ans après Bac',
  '2 ans après "Bac+3ans"',
  '2 Années Préparatoires au Cycle Ingénieur',
  '3 ans après "2ans"',
  'Bac + 5 ans',
  '5ans après bac réparties en cycle prépa intégré (2ans) et cycle de spécialisation (3ans)',
  'Bac + 6 ans',
  '3 ans après "2 Années Préparatoires"',
  'Bac + 7 ans',
  'Doctorat',
  '5 ans après bac ( 2 années préparatoires et 3 ans cycle de spécialisation)',
  'Bac + 4 ans',
  '3 ans après Bac(fondamental)',
  '3 ans après Bac (professionnel)',
  '2 ans après un diplôme "Bac+3ans" (fondamental)',
  '2 ans après un diplôme "Bac+3ans" (professionnel)',
  "INGENIEUR D'APPLICATION OU EQUIVALENT",
  "DIPLOME D'AGREGATION DES ECOLES NATIONALES",
  "D.E.S.S (DIPLOM D'ETUDES SUPER. SPECIALISEES)",
  'D.E.A OU EQUIVALENT'
];

// ===========================
// 📍 LIEUX D'OBTENTION MAROC
// ===========================
export const lieuxObtentionMaroc = [
  'Province',
  "Préfecture d'Arrond. Aïn Chock",
  "Préfecture d'Arrond. Aïn Sebaa",
  "Préfecture d'Arrond. Al Fida Mers",
  "Préfecture d'Arrond. Ben M'sik",
  "Préfecture d'Arrond. Casa Anfa",
  "Préfecture d'Arrond. Hay Hassani",
  "Préfecture d'Arrond. Moulay R'chid",
  "Préfecture d'Arrond. Sidi Bernoussi",
  'Préfecture: Agadir-Ida -Ou-Tanane',
  'Préfecture: Fès',
  'Préfecture: Inezgane- Ait Melloul',
  'Préfecture: Marrakech',
  'Préfecture: M\'Diq-Fnideq',
  'Préfecture: Meknès',
  'Préfecture: Mohammadia',
  'Préfecture: Oujda-Angad',
  'Préfecture: Rabat',
  'Préfecture: Salé',
  'Préfecture: Skhirate- Témara',
  'Préfecture: Tanger-Assilah',
  'Province: Al  Haouz',
  'Province: Al Hoceima',
  'Province: Aousserd',
  'Province: Assa-Zag',
  'Province: Azilal',
  'Province: Béni Mellal',
  'Province: Benslimane',
  'Province: Berkane',
  'Province: Berrechid',
  'Province: Boujdour',
  'Province: Boulemane',
  'Province: Chefchaouen',
  'Province: Chichaoua',
  'Province: Chtouka- Ait Baha',
  'Province: Driouch',
  'Province: El  Hajeb',
  'Province: El Jadida',
  'Province: El Kelâa des  Sraghna',
  'Province: Errachidia',
  'Province: Essaouira',
  'Province: Es-Semara',
  'Province: Fahs-Anjra',
  'Province: Figuig',
  'Province: Fquih Ben Salah',
  'Province: Guelmim',
  'Province: Guercif',
  'Province: Ifrane',
  'Province: Jerada',
  'Province: Kénitra',
  'Province: Khémisset',
  'Province: Khénifra',
  'Province: Khouribga',
  'Province: Laâyoune',
  'Province: Larache',
  'Province: Médiouna',
  'Province: Midelt',
  'Province: Moulay Yacoub',
  'Province: Nador',
  'Province: Nouaceur',
  'Province: Ouarzazate',
  'Province: Oued Ed-Dahab',
  'Province: Ouezzane',
  'Province: Rehamna',
  'Province: Safi',
  'Province: Sefrou',
  'Province: Settat',
  'Province: Sidi Bennour',
  'Province: Sidi Ifni',
  'Province: Sidi Kacem',
  'Province: Sidi Slimane',
  'Province: Tan-Tan',
  'Province: Taounate',
  'Province: Taourirt',
  'Province: Tarfaya',
  'Province: Taroudannt',
  'Province: Tata',
  'Province: Taza',
  'Province: Tétouan',
  'Province: Tinghir',
  'Province: Tiznit',
  'Province: Youssoufia',
  'Province: Zagora'
];

// ===========================
// 🧩 COMPOSANT PRINCIPAL
// ===========================
const DiplomeSelectors = ({ form, onChange, prefix = '' }) => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      width: '100%'
    },
    formRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1rem'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151'
    },
    select: {
      padding: '0.5rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.375rem',
      fontSize: '14px',
      outline: 'none',
      transition: 'border-color 0.2s',
      cursor: 'pointer'
    },
    hint: {
      fontSize: '12px',
      color: '#6b7280',
      fontStyle: 'italic'
    }
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    // Retirer le prefix si présent pour avoir le bon nom
    const fieldName = name.replace(prefix, '');
    onChange({ target: { name: fieldName, value } });
  };

  return (
    <div style={styles.container}>
      {/* Série Baccalauréat */}
      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Série Baccalauréat</label>
          <select
            name={`${prefix}serieBaccalaureat`}
            value={form.serieBaccalaureat || ''}
            onChange={handleSelectChange}
            style={styles.select}
          >
            <option value="">Sélectionner une série...</option>
            <optgroup label="🇲🇦 Baccalauréat Marocain">
              {baccalaureatMarocain.map((bac) => (
                <option key={bac.code} value={bac.code}>
                  {bac.libelle}
                </option>
              ))}
            </optgroup>
            <optgroup label="🌍 Baccalauréat Étranger">
              {baccalaureatEtranger.map((bac) => (
                <option key={bac.code} value={bac.code}>
                  {bac.libelle}
                </option>
              ))}
            </optgroup>
          </select>
          <span style={styles.hint}>
            Choisissez la série de votre baccalauréat
          </span>
        </div>
      </div>

      {/* Lieu d'Obtention du Diplôme */}
      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Lieu d'Obtention du Diplôme</label>
          <select
            name={`${prefix}lieuObtentionDiplome`}
            value={form.lieuObtentionDiplome || ''}
            onChange={handleSelectChange}
            style={styles.select}
          >
            <option value="">Sélectionner un lieu...</option>
            {form.pays === 'Maroc' ? (
              <>
                {lieuxObtentionMaroc.map((lieu) => (
                  <option key={lieu} value={lieu}>
                    {lieu}
                  </option>
                ))}
              </>
            ) : (
              <option value="Province étrangère">Province étrangère</option>
            )}
          </select>
          <span style={styles.hint}>
            {form.pays === 'Maroc' 
              ? 'Sélectionnez la province/préfecture au Maroc'
              : 'Pour les diplômes étrangers, sélectionnez "Province étrangère"'}
          </span>
        </div>
      </div>

      {/* Diplôme d'Accès */}
      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Diplôme d'Accès</label>
          <select
            name={`${prefix}diplomeAcces`}
            value={form.diplomeAcces || ''}
            onChange={handleSelectChange}
            style={styles.select}
          >
            <option value="">Sélectionner un diplôme...</option>
            {diplomesAcces.map((diplome) => (
              <option key={diplome} value={diplome}>
                {diplome}
              </option>
            ))}
          </select>
          <span style={styles.hint}>
            Choisissez le diplôme qui vous donne accès à cette formation
          </span>
        </div>
      </div>
    </div>
  );
};

export default DiplomeSelectors;